import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-configs-list',
  templateUrl: './configs-list.component.html'
})

export class ConfigsListComponent implements OnInit {

  url: string      = 'configs';

  data: Array<any> = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  type = 'admin';

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getDataTwo(this.url,'', this.type, this.currentPage, this.itemsPerPage).subscribe((response) => {      //console.log('response', response);
      this.data = response.data;
    });
  }

  deleteData(id: string): void {
    if (!confirm('Desea eliminar el registro?')) {
      return;
    }

    this.dataService.deleteData(`${this.url}/delete/${id}`).subscribe(response => {

      if (response.rst) {
        this.messageService.add(response.msg, 'info');
      } else {
        this.messageService.add(response.msg, 'danger');
      }

      this.getData();
    });
  }
}
